import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND}/api`,
});
export { api };

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      original &&
      !original._retry &&
      !original.url.includes("/auth/")
    ) {
      original._retry = true;
      try {
        const { data } = await axios.post(`${BACKEND}/api/auth/refresh`, {}, { withCredentials: true });
        localStorage.setItem("kc_token", data.access_token);
        return api(original);
      } catch (e) {
        localStorage.removeItem("kc_token");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Something went wrong — please try again";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(", ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const imgSrc = (u) => {
  if (!u) return "";
  if (u.startsWith("/")) return `${BACKEND}${u}`;
  return u;
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export default api;
